import script from "./AnnotationFilterButton.vue?vue&type=script&lang=js"
export * from "./AnnotationFilterButton.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__